var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-footer", { staticClass: "my_reglog_footer" }, [
    _c("div", { staticClass: "my_reglog_footer_path" }, [
      _c("div", { staticStyle: { width: "1920px", margin: "auto" } }, [
        _c("li", { staticClass: "my_reglog_footer_d" }, [
          _vm._v(
            "\n            上海阅尔基因技术有限公司 沪公网安备31011002005278号 沪ICP备17045756号-2\n          "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-right": "200px" } }, [
          _c("li", { staticClass: "my_reglog_footer_f" }, [
            _vm._v("\n              Powered by WizInno\n")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d97b5d06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d97b5d06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/log_reg_footer.vue
// module id = null
// module chunks = 